import PropTypes from "prop-types";

function Card (props) {

  const getCor = () => {
    if (!props.cor) return 'primary';
    return props.cor;
  }

  const botaoCustom = props.botaoCustom ? props.botaoCustom: '';
  const botaoMaximizar = props.botaoMaximizar ? <button type="button" className="btn btn-tool" data-card-widget="maximize"><i className="fas fa-expand"></i></button>: '';
  const botaoColapsar = props.botaoColapsar ? <button type="button" className="btn btn-tool" data-card-widget="collapse"><i className="fas fa-minus"></i></button>: '';
  const botaoFechar = props.botaoFechar ? <button type="button" className="btn btn-tool" data-card-widget="remove"><i className="fas fa-times"></i></button>: '';
  const botoes = () => {
    if (props.botaoFechar || props.botaoMaximizar || props.botaoColapsar || props.botaoCustom){
      return (
        <div className={"card-tools"}>
          {botaoCustom}
          {botaoMaximizar}
          {botaoColapsar}
          {botaoFechar}
        </div>
      )
    } return "";
  }
  const cabecalho = () => {
    if (!props.titulo) return "";
    return (
      <div className='card-header'>
        <h3 className='card-title'>{props.titulo}</h3>
        {botoes()}
      </div>
    )
  };

  return (
    <div className={"card "+props.className + " " + getCor()}>
      {cabecalho()}
      <div className="card-body table-responsive mt-2" style={{zIndex: "inherit"}}>
        {props.children}
      </div>
    </div>
  );
}
Card.propTypes = {
  badge: PropTypes.string,
  badgeCor: PropTypes.string,
  botaoCustom: PropTypes.any,
  botaoFechar: PropTypes.bool,
  botaoMaximizar: PropTypes.bool,
  botaoColapsar: PropTypes.bool,
  className: PropTypes.string,
  cor: PropTypes.string,
  rodape: PropTypes.any,
  titulo: PropTypes.string,

}
export {Card}
